import { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';

import { useGetAgentDenounces } from '../../hooks/useDenounceService';

import Header from '../../components/Header/Header';
import BottomMenu from '../../components/BottomMenu/BottomMenu';
import DenounceSummary from '../../components/DenounceSummary/DenounceSummary';

import './Denounces.scss';

function Denounces() {
  const navigate = useNavigate();

  const { authUser, isAuthorized } = useContext(AuthContext);
  const [ , denounces] = useGetAgentDenounces({
    agentId: authUser?.roles?.agent?.id
  })

  useEffect(() => {
    if (!isAuthorized) navigate('/login');
  }, [isAuthorized, navigate]);

  function handleGoToDenounceDetails(denounceId) {
    navigate('/denounce-details', {
      state: {
        denounceId
      }
    });
  }

  return (
    <div className="inner-page denounces-page">
      <Header
        pageTitle="Denúncias" 
      />
      <div className="inner-page-content-container">
        {denounces?.map((denounce) => {
          const denounceId = denounce?.id;
          return (
            <DenounceSummary
              key={denounceId}
              denounce={denounce}
              handleGoToDenounceDetails={handleGoToDenounceDetails} />
          );
        })}
      </div>
      <BottomMenu />
    </div>
  );
}

export default Denounces;
